"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ImageBorderIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M3 17v3.41c0 .33.26.59.59.59H7v-2H5v-2zm16 0v2h-2v2h3.41c.33 0 .59-.26.59-.59V17zM3.59 3a.59.59 0 0 0-.59.59V7h2V5h2V3zM17 3v2h2v2h2V3.59a.59.59 0 0 0-.59-.59zm-3 2h2V3h-2zM8 5h5V3H8zm11 5h2V8h-2zM3 12h2V8H3zm16 4h2v-5h-2zM3 16h2v-3H3zm9 5h4v-2h-4zm-4 0h3v-2H8z"/></svg>`
}, props));
ImageBorderIcon.displayName = 'ImageBorderIcon';
var _default = exports.default = ImageBorderIcon;